/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";

const IconCancel = ({
  color = "currentColor",
  strokeWidth = "2",
  size = "xs",
  className = "",
}: {
  color?: string;
  strokeWidth?: string;
  size?: "xs" | "sm" | "lg";
  className?: string;
}) => {
  let sizeClass = "";
  if (size === "xs") {
    sizeClass = "w-3 h-3";
  }

  if (size === "sm") {
    sizeClass = "w-4 h-4";
  }

  if (size === "lg") {
    sizeClass = "w-10 h-10";
  }

  return (
    <svg
      className={classNames(sizeClass, className)}
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      test-id="aYOo8f2L"
    >
      <path
        d="M37.75 0.986328L19.25 19.4863L37.75 37.9863"
        stroke={color}
        strokeWidth={strokeWidth}
        test-id="mGc4AHXp"
      />

      <path
        d="M1.25 0.986328L19.75 19.4863L1.25 37.9863"
        stroke={color}
        strokeWidth={strokeWidth}
        test-id="aaWJzsPZ"
      />
    </svg>
  );
};

export default IconCancel;
